export default {
    downloadUrl(fileId) {
        return 'systemfiles/' + fileId;   
    }
}
